import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalConstants } from '../global-constants';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsuarioPerfil } from '../comun/models/misdatos.model';
import { MisdatosService } from '../comun/services/misdatos.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, OnDestroy {
  global: any = GlobalConstants;
  anyo: number = 2024;
  private misdatosSub!: Subscription;
  misdatos: any = {};

  imglogo = GlobalConstants.urlServer + 'img/iguau-logo-blanco.svg';
  imgDecoracion = GlobalConstants.urlServer + 'img/iguau-footer-decoracion.svg';
  //backgroundImage = GlobalConstants.urlServer + 'img/logo_boda_marcaagua_blanco.png';

  constructor(private misdatosService: MisdatosService,) {}

  ngOnInit(): void {
    this.anyo = new Date().getFullYear();
    this.getMisDatos();
  }

  ngOnDestroy(): void {
    this.misdatosSub?.unsubscribe();
  }

  getMisDatos() {
    // 1. Escuchamos el observable misdatos$
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is UsuarioPerfil => misdatos !== null)
      )
      .subscribe((misdatos: UsuarioPerfil) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
      });
  }

}
